import PasswordValidator from 'password-validator';
import checkIcon from '../images/valid.svg';
import crossIcon from '../images/invalid.svg';
const schema = new PasswordValidator()
    .is().min(8)
    .has().uppercase()
    .has().lowercase()
    .has().digits()
    .has().symbols()


const validationRules = {
    lowercase: {
        message: "A lowercase character",
        validate: (password) => new PasswordValidator().has().lowercase().validate(password)
    },
    uppercase: {
        message: "An uppercase character",
        validate: (password) => new PasswordValidator().has().uppercase().validate(password)
    },
    digits: {
        message: "A number",
        validate: (password) => new PasswordValidator().has().digits().validate(password)
    },
    min: {
        message: "Minimum 8 characters",
        validate: (password) => new PasswordValidator().is().min(8).validate(password)
    },
    symbols: {
        message: "A special character",
        validate: (password) => new PasswordValidator().has().symbols().validate(password)
    }
};

function validatePassword(password, feedbackElement) {
    feedbackElement.innerHTML = ''; // Clear previous feedback
    let allValid = true;

    for (const [key, rule] of Object.entries(validationRules)) {
        const isValid = rule.validate(password);

        const feedback = document.createElement('div');
        feedback.innerHTML = isValid
            ? `<img src="${checkIcon}" alt="Check Icon" class="feedback-icon"> ${rule.message}`
            : `<img src="${crossIcon}" alt="Cross Icon" class="feedback-icon"> ${rule.message}`;

        feedback.style.color = isValid ? 'green' : 'rgba(0,0,0,.5)';
        feedbackElement.appendChild(feedback);

        if (!isValid) allValid = false;
    }

    return allValid;
}

function validateGeoJson(input, cityFeedback) {
    let isPolygon
    try {
        const parsed = JSON.parse(input);
        isPolygon = parsed.type !== "Point";

        if (isPolygon) {
            cityFeedback.textContent = '';
        } else {
            cityFeedback.textContent = 'Please select a valid city';
            cityFeedback.style.color = 'red';
        }
    } catch (e) {
        isPolygon = false;
        cityFeedback.textContent = 'Please select a valid city';
        cityFeedback.style.color = 'red';
    }

    return isPolygon
}

function validateEmail(email, feedbackElement, submitted = false) {
    const restrictedDomains = ['gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com'];
    const domain = email.split('@')[1];

    feedbackElement.textContent = '';

    if ((domain && restrictedDomains.includes(domain.toLowerCase())) || (domain === undefined) && submitted) {
        feedbackElement.textContent = 'Please use a work email (no Gmail, Yahoo, etc.)';
        feedbackElement.style.color = 'red';
        return false;
    } else {
        feedbackElement.textContent = '';
        feedbackElement.style.color = 'green';
        return true;
    }
}

function updateSubmitButtonState(emailValid, passwordValid, isGeoJsonValid) {
    const submit = document.getElementsByClassName('submit-btn')[0];
    submit.disabled = !(emailValid && passwordValid && isGeoJsonValid);
}

function togglePasswordVisibility(passwordInput, toggleButton) {
    const isPasswordVisible = passwordInput.type === 'text';

    passwordInput.type = isPasswordVisible ? 'password' : 'text';
}

document.addEventListener('DOMContentLoaded', () => {
    const emailInput        = document.getElementById('user_email');
    const emailFeedback     = document.getElementById('email-feedback');
    const passwordInput     = document.getElementById('password');
    const passwordFeedback  = document.getElementById('password-feedback');
    const cityFeedback      = document.getElementById('city-feedback');
    const togglePasswordBtn = document.getElementById('toggle-password-visibility');
    const cityGeojson       = document.getElementById('city-geojson');

    emailInput.parentNode.appendChild(emailFeedback);

    let isEmailValid = false;
    let isPasswordValid = false;
    let isGeoJsonValid = false;

    if (emailInput && emailFeedback) {
        validateEmail(emailInput.value, emailFeedback);
        emailInput.addEventListener('input', () => {
            isEmailValid = validateEmail(emailInput.value, emailFeedback);
            // updateSubmitButtonState(isEmailValid, isPasswordValid, isGeoJsonValid);
        });
    }

    if (passwordInput && passwordFeedback) {
        validatePassword(passwordInput.value, passwordFeedback);
        passwordInput.addEventListener('input', () => {
            isPasswordValid = validatePassword(passwordInput.value, passwordFeedback);
            // updateSubmitButtonState(isEmailValid, isPasswordValid, isGeoJsonValid);
        });
    }

    if (togglePasswordBtn && passwordInput) {
        togglePasswordBtn.addEventListener('click', () => {
            togglePasswordVisibility(passwordInput, togglePasswordBtn);
        });
    }

    if (cityGeojson) {
        const observer = new MutationObserver(() => {
            isGeoJsonValid = validateGeoJson(cityGeojson.value, cityFeedback);
            // updateSubmitButtonState(isEmailValid, isPasswordValid, isGeoJsonValid);
        });

        observer.observe(cityGeojson, {
            attributes: true,
            attributeFilter: ['value']
        });
    }

    const submit = document.getElementsByClassName('submit-btn')[0];
    submit.addEventListener('click', (e) => {
        e.preventDefault();

        isEmailValid    = validateEmail(emailInput.value, emailFeedback, true);
        isPasswordValid = validatePassword(passwordInput.value, passwordFeedback);
        isGeoJsonValid  = validateGeoJson(cityGeojson.value, cityFeedback);

        if (!isEmailValid) {
            emailFeedback.textContent = 'Please use a work email (no Gmail, Yahoo, etc.)';
            emailFeedback.style.color = 'red';
        } else {
            emailFeedback.textContent = '';
        }

        if (!isGeoJsonValid) {
            cityFeedback.textContent = 'Please select a valid city';
            cityFeedback.style.color = 'red';
        } else {
            cityFeedback.textContent = '';
        }

        if (isEmailValid && isPasswordValid && isGeoJsonValid) {
            document.querySelector('form').submit();
        }
    });
});